import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  dialogTitleContainer: {
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
    paddingTop: theme.spacing(1.5),
    paddingBottom: theme.spacing(1.5),
    backgroundColor: theme?.checklookup?.headerBackgroundColor,
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
  },
  dialogContent: {
    padding: theme.spacing(2),
  },
  dialogTitle: {
    color: theme?.checklookup?.headerTextColor,
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(0.5),
    color: theme?.checklookup?.closeIconColor,
  },
  primaryButton: {
    backgroundColor: theme?.checklookup?.primaryButtonBackgroundColor,
    color: theme?.checklookup?.primaryButtonTextColor,
    marginLeft: '8px',
    boxShadow: 'none',
    width: '150px',
    '&:hover': {
      backgroundColor: theme?.checklookup?.primaryButtonBackgroundColor,
      color: theme?.checklookup?.primaryButtonTextColor,
    }
  },
  secondaryButton: {
    borderColor: theme?.checklookup?.secondaryButtonBorderColor,
    color: theme?.checklookup?.secondaryButtonTextColor,
    boxShadow: 'none',
    width: '150px',
  },
}));

export default useStyles;

